package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_03_07_Day_3() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Bigglesworth is too tired to fish today. Caper learns about knots and nautical facts.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("During Annette and Korvis’s watch, Korvis hears the beating of heavy wings nearby and hears something near the bow. At the stern, 120 feet from Korvis, is an adult dragon, potentially a black dragon (it is dark).  Korvis alerts the crew and heroes. The dragon seems surprised that Korvis saw him.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.QUOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Umbraxus has arrived. Abandon your mission!")
        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Umbra, from Latin, means shade or shadow. Unconfirmed but likely source of name ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Umbra")
            }
            org.jetbrains.compose.web.dom.Text("xus.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Annette hastens Bigglesworth, and Falorn blesses. Tuesday asks the dragon why he is here!")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.QUOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Your meddling has been problematic. This is a warning!  Turn around now and survive!")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Tuesday transforms into a giant ape, drops onto the dragon, puts him in a headlock, and punches him in the face. Korvis flanks the dragon using the Blessing of the Raven Queen. The dragon spews out a cone of shadowy, corrosive energy. Several of the heroes are injured; Droo is nearly killed. Caper rebukes the violent. Fire from the breath has spread to the sail and some nearby boxes. Caper gives the dragon an ultimatum.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.QUOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Creature of Evil, you must leave now or surely perish.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Umbraxus laughs.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Caper smites. Falorn flame strikes. The dragon seems to be immune to fire damage but vulnerable to radiant damage.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Dirk casts Redirect Flow to extinguish the flames on the ship’s sails with ocean water.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Tuesday prepares a ready action. If the dragon doesn’t surrender, he will jump off the ship and drag it beneath the tides. But before Tuesday has the opportunity to carry out this plan, Umbraxus says")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.QUOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" You are so annoying! To your doom!")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("He transforms into smoke, moves 80 feet away, and disappears.")
    }
}
